<template>

  <div>
    <div class="breadcrumb-list">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">Settings</li>
      </ol>
    </div>
    <div class="main-box two-column">
      <!--      sidebar setting start-->
      <sidebar></sidebar>
      <!--      sidebar setting end-->
      <div class="setting-info-wrp">
        <!-- location -->
        <div class="loacatoin-box">
          <div class="sett-head">
            <h1>Holidays for <span class="text-capitalize">{{ company_name }}</span></h1>
          </div>
          <div class="">
            <div class="row mb-10">
              <div class="col-12">
                <div class="row">
                  <div class="col-lg-6">
                    <label>Name <span class="text-danger">*</span></label>
                    <div class="form-group">
                      <input type="text" placeholder="Name" v-model="newHoliday.name" id="title"
                             class="form-control text-capitalize">
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <label>Date <span class="text-danger">*</span></label>
                    <div class="form-group">
                      <input type="date" placeholder="Date" v-model="newHoliday.date" id="address" class="form-control"
                             ref="autocomplete">
                    </div>
                  </div>

                  <div class="col-lg-6">
                    <label>Full Day/Half Day </label>
                    <div class="form-group">
                      <select name="holiday_type" v-model="newHoliday.type" id="holiday_length" class="form-control">
                        <option value="0">Select</option>
                        <option value="full_day">Full Day</option>
                        <option value="half_day">Half Day</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <label>Repeats Annually </label>
                    <div class="form-group">
                      <input type="checkbox" placeholder="Latitude" v-model="newHoliday.repeat_annually">
                    </div>
                  </div>
                  <div class="col-lg-12 text-right mb-10">
                    <button @click="addHoliday" v-if="newHolidayBtn" class="btn btn-info" type="button">Save</button>
                    <button @click="updateHoliday(newHoliday)" v-if="updateHolidayBtn" class="btn btn-info" type="button">Update</button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <table class="table">
            <thead>
            <th class="text-page">Name</th>
            <th class="text-page">Date</th>
            <th class="text-page">Full Day/Half Day</th>
            <th class="text-page">Repeats Annually</th>
            <th class="text-center text-page">Actions</th>
            </thead>
            <tbody>
            <tr v-for="holiday in holidays" :key="holiday.id">
              <td class="text-page text-capitalize">{{ holiday.name }}</td>
              <td class="text-page text-capitalize">{{ holiday.date }}</td>
              <td class="text-page">{{ (holiday.type == 'full_day') ? 'Full Day' : 'Half Day' }}</td>
              <td class="text-page">{{ holiday.repeat_annually ? 'Yes' : 'No' }}</td>
              <td class="text-center">
                <span class="ico-pencil text-primary" style="cursor: pointer;" @click="editFun(holiday)"></span>
                <span class="ico-delete text-danger ml-5" style="cursor: pointer;"
                      @click="deleteFun(holiday)"></span>
              </td>
            </tr>
            <tr v-if="!holidays.length">
              <td colspan="5" class="text-center text-page">No Data Found.</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

</template>
<style scoped>
.table tr {
  border-top: none;
}
</style>
<script>
import sidebar from "./sidebar";
import Swal from "sweetalert2";
import {required} from "vuelidate/lib/validators";

export default {
  components: {
    sidebar
  },
  props: [],
  data() {
    return {
      newHolidayBtn: true,
      updateHolidayBtn: false,
      holidays: [],
      newHoliday: {
        company_id: this.$store.getters.getSelectedCompany.id,
        name: '',
        date: '',
        repeat_annually: false,
        type: ''
      },
      selectedHoliday: null,
      company_id: this.$store.getters.getSelectedCompany.id,
      company_name: this.$store.getters.getSelectedCompany.name,
    }
  },
  validations: {
    form: {
      title: {required},
      date: {required}
    }
  },

  watch: {},
  created() {

  },
  mounted() {
    this.fetchHolidays();
  },
  methods: {
    fetchHolidays() {
      let params = {
        company_id: this.company_id
      };
      this.$axios.get(this.$Holidays, {  params: params,headers: this.getAuthHeader()})
        .then(response => {
          this.holidays = response.data.result;
        })
        .catch(error => {
          console.error('Error fetching holidays:', error);
        });
    },
    addHoliday() {
      this.$axios.post(this.$Holidays, this.newHoliday, {headers: this.getAuthHeader()})
        .then(response => {
          this.holidays.push(response.data.result);
          this.newHoliday.name='';
          this.newHoliday.date='';
          this.newHoliday.repeat_annually=false;
          this.newHoliday.type='';
          this.newHoliday.company_id= this.$store.getters.getSelectedCompany.id;
          $root.$toast.success('Added successfully.');
        })
        .catch(error => {
          console.error('Error adding holiday:', error);
        });
    },
    editFun(holiday) {
      this.newHolidayBtn = false;
      this.updateHolidayBtn = true;
      this.newHoliday = holiday;
    },
    updateHoliday(holiday) {
      this.$axios.put(this.$Holidays+'/'+holiday.id, holiday, {headers: this.getAuthHeader()})
        .then(response => {
          this.newHoliday = {
            name: '',
            date: '',
            repeat_annually: false,
            type: ''
          };
        })
        .catch(error => {
          console.error('Error updating holiday:', error);
        });
    },
    deleteFun(holiday) {
      new Swal({
        title: "Delete Holiday?",
        icon: "warning",
        text: "Are you sure? You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!"
      }).then((result) => {
        if (result.value) {
          this.$axios.delete(this.$Holidays+'/'+holiday.id, {headers: this.getAuthHeader()})
            .then(response => {
              this.holidays = this.holidays.filter(item => item.id !== holiday.id);
              $root.$toast.error('Deleted successfully.');
            })
            .catch(error => {
              console.error('Error deleting holiday:', error);
            });
        }
      });


    },
  }
}
</script>
<style scoped>

</style>
